import { TourSequence } from '@/domain/project-tour-ontour/entities/project-tour-ontour-sequence.entity';

import { TourSequenceDto } from './project-tour-sequence.dto.schema';

type EditTourSequenceDto = {
  name: string;
};

export class TourSequenceMapper {
  static dtoToEntity(dto: TourSequenceDto): TourSequence {
    return {
      id: dto.id,
      name: dto.name,
    };
  }

  static prepareEditSequenceDto(
    tourSequence: TourSequence,
  ): EditTourSequenceDto {
    return {
      name: tourSequence.name,
    };
  }
}
